import React from 'react';
import { Box, Typography } from '@mui/material';
import ColorList from '../components/ColorManagement/ColorList';
//import ColorDebugTest from '../components/ColorManagement/ColorDebugTest';

const ColorManagement: React.FC = () => {

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h4">Color Management</Typography>
      </Box>
      <ColorList />
    </Box>
  );
};

export default ColorManagement;
